import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExamService } from 'src/app/providers/exam/exam.service';
import { map } from 'rxjs/operators';
import { ExamModalComponent } from 'src/app/modals/exam-modal/exam-modal.component';
import { DeleteConfirmDialogComponent } from 'src/app/shared/delete-confirm-dialog/delete-confirm-dialog.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { StyleService } from '../../providers/style.service';
import { Util } from '../../providers/util.service';
import { ClassService } from '../../providers/class/class.service';

@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  styleUrls: ['./exam.component.scss'],
})
export class ExamComponent implements OnInit, OnDestroy {
  baseurl = Util.GetBaseUrl();
  public examData;

  public CardView = true;
  public ListView = false;
  public SelectedExam = null;
  public CurrentClass = null;

  constructor(
    public dialog: MatDialog,
    public examService: ExamService,
    public styleControl: StyleService,
    private classService: ClassService,
  ) {
  }

  ngOnDestroy(): void {
    this.styleControl.setDisablePadding(false);
  }

  openDialogExam(): void {
    const dialogRef = this.dialog.open(ExamModalComponent, {
      width: '350px',
      data: {
        title: 'Create new exam'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getexamData();
    });
  }

  ngOnInit(): void {
    this.getexamData();
    this.styleControl.setDisablePadding(true);
  }

  ToggleToCardView() {
    //console.log("change to card view");
    this.CardView = true;
    this.ListView = false;
  }

  ToggleToListView() {
    //console.log("change to list view");
    this.CardView = false;
    this.ListView = true;
  }

  Select(Exam) {
    console.log(Exam);
    if (this.SelectedExam == Exam) {
      this.SelectedExam = null;
      this.ToggleToCardView();
    } else {
      this.GetClass(Exam.class_SysRef)
      this.SelectedExam = Exam;
      this.ToggleToListView();
    }
  }


  getexamData() {
    this.examService.viewExam()
      .pipe(map(
        data => { return data }
      )).subscribe(
        data => {
          console.log(data);
          this.examData = data;
      });
  }

  // editing exam
  editExam(examObj) {
    //console.log("editing", examObj);
    const dialogRef = this.dialog.open(ExamModalComponent, {
      width: '350px',
      data: {
        id: examObj.sysRef,
        class_sysref: examObj.class_SysRef,
        examType_SysRef: examObj.examType_SysRef,
        description: examObj.description,
        examDate: examObj.examDate,
        passMark: examObj.passMark,
        title: 'Edit exam ' + examObj.description,
        questionAmount: examObj.questionAmount
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getexamData();
    });
  }

  reGenarateExam(Exam) {
    console.log(Exam);
    this.examService.reGenerateExam(Exam.sysRef).subscribe(x => {
      console.log(x);
    })
  }

  // deleting a exam
  deleteExam(examObj): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '350px',
      data: {
        component: 'exam',
        id: examObj.sysRef,
        title: 'Confirm Delete',
        message: 'Are you sure, you want to remove class: ' + examObj.description
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getexamData();
    });
  }

  DownloadExam(PaperSysref) {
    return this.baseurl + "/api/PDF/Exam?PaperSysref=" + PaperSysref;
  }

  DownloadPaper(PaperSysref) {
    return this.baseurl + "/api/PDF/Answer?PaperSysref=" + PaperSysref;
  }

  GetClass(id) {
    this.classService.getClass(id).subscribe(x => {
      console.log(x)
      this.CurrentClass = x;
    })
  }
}
